/**
 * Checks if current installation is local
 *
 * @type {boolean}
 */
export const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

/**
 * Create POST headers
 *
 * @return Object
 */
export const getPostHeaders = () => {
    const headers = {'Cache-Control': 'no-cache'};
    const token = localStorage.getItem('token');
    headers.Authorization = 'Bearer ' + token;
    return headers;
};

/**
 * Create GET headers
 *
 * @return Object
 */
export const getGetHeaders = () => {
    const headers = {'Cache-Control': 'no-cache'};
    const token = localStorage.getItem('token');
    headers.Authorization = 'Bearer ' + token;
    return headers;
};

/**
 * Retrieve System and set to lowercase for ElasticSearch calls
 */
export const setSystemToLowercase = () => {
    const system = encodeURIComponent(localStorage.getItem('system'));
    return system.toLowerCase();
};

/**
 * Create a system/mode string for API paths
 *
 * @return {string}
 */
export const makeSystemModePath = () => {
    const system = setSystemToLowercase();
    const mode = encodeURIComponent(localStorage.getItem('mode'));
    return system + "/" + mode;
};

export const removeSearchQuery = () => {
    const url = new URL(window.location.href);
    url.search = "";
    window.history.replaceState({}, document.title, url.pathname);
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/serverFunctions.js